import { Injectable, inject } from '@angular/core';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = 'xlsx';
import { FileSaverService } from 'ngx-filesaver';
@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  private fileSaverService = inject(FileSaverService);



  public exportAsExcelFile(json: any[], excelFileName: string, extension: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName, extension);
  }

  public saveAsExcelFile(buffer: any, fileName: string, extension: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    this.fileSaverService.save(data, fileName + '_export_' + new Date().getTime() + '.' + extension || EXCEL_EXTENSION);
  }

}
